export default __webpack_public_path__ + "static/media/ic_payroll.2bbaf88f.svg";